/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  indexTitle: {
    id: 'account.index.title',
    defaultMessage: 'Title',
  },
  alternativeUpload: {
    id: 'account.lineItem.alternativeUpload.title',
    defaultMessage: 'Alternative upload title',
  },
  newsletterPageTitle: {
    id: 'account.newsletter.page_title',
    defaultMessage: 'Email preferences',
  },
});
